// Settings › Your data: everything the household has in Matlist, as one JSON
// file the member keeps (the terms and privacy policy promise an export at any
// time; GDPR art. 20). Pure: useDataExport reads the rows, this shapes them.
//
// Items are split the way people think of them: what is on the list now (open
// and in the basket) and the history (soft-deleted: finished trips, deletes).
// Photos are named by their path in the household's private bucket; the
// pictures themselves stay there (a signed URL would be dead in an hour).

import type { Category, Household, Item, MealTemplate, Member, PlannedMeal, Recipe, Store, Trip } from './supabase'

export const EXPORT_FORMAT = 'matlist-export'
export const EXPORT_VERSION = 1

export interface ExportRows {
  household: Household
  members: Member[]
  categories: Category[]
  items: Item[]
  recipes: Recipe[]
  plannedMeals: PlannedMeal[]
  mealTemplates: MealTemplate[]
  stores: Store[]
  trips: Trip[]
}

export function buildExport(rows: ExportRows, exportedAt: Date) {
  const h = rows.household
  return {
    format: EXPORT_FORMAT,
    version: EXPORT_VERSION,
    exported_at: exportedAt.toISOString(),
    household: { id: h.id, name: h.name, created_at: h.created_at, plan: h.subscription_status, plan_until: h.plan_expires_at },
    members: rows.members.map(m => ({ id: m.id, display_name: m.display_name, joined_at: m.created_at })),
    categories: rows.categories,
    list: rows.items.filter(i => !i.deleted_at),
    history: rows.items.filter(i => !!i.deleted_at),
    recipes: rows.recipes,
    meal_plan: rows.plannedMeals,
    week_templates: rows.mealTemplates,
    stores: rows.stores,
    trips: rows.trips,
  }
}

/** "matlist-the-bergs-2026-10-26.json": the household's name, plain, and the day. */
export function exportFileName(householdName: string, day: Date): string {
  const slug = householdName.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'household'
  return `matlist-${slug}-${day.toISOString().slice(0, 10)}.json`
}
